// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../bundles/Auth/Auth.res.js";
import * as Navigation from "../primitives/Navigation.res.js";
import * as ApolloConfig from "./ApolloConfig.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function Providers(props) {
  return JsxRuntime.jsx(Navigation.Provider.make, {
    children: JsxRuntime.jsx(Navigation.ConnectReactAriaProvider.make, {
      children: JsxRuntime.jsx(Auth.Provider.make, {
        children: JsxRuntime.jsx(ApolloConfig.Provider.make, {
          children: props.children
        }),
        initialState: props.auth
      })
    }),
    history: props.history
  });
}

let make = Providers;

export {
  make,
}
/* Auth Not a pure module */
